export default __webpack_public_path__ + "static/media/start.cbc13abd.png";